import booleanPointInPolygon from '@turf/boolean-point-in-polygon';
import { Map } from 'mapbox-gl';
import type { MapRef } from 'react-map-gl/mapbox';
import getMapBoundingBox from '@alltrails/explore-service/utils/getMapBoundingBox';
import type { LngLat } from '../types/Geo';

const isLocationVisible = (map: Map | MapRef, location: LngLat) => {
  const boundingBox = getMapBoundingBox(map);
  return booleanPointInPolygon(location, {
    type: 'Polygon',
    coordinates: [
      [boundingBox.bottomLeft, boundingBox.topLeft, boundingBox.topRight, boundingBox.bottomRight, boundingBox.bottomLeft].map(({ lat, lng }) => [
        lng,
        lat
      ])
    ]
  });
};

export default isLocationVisible;
